module.exports = __webpack_public_path__ + "media/images/product-bg-e9e14c327f9d5c19938afba0140ef7a1.svg";